import { InjectionToken, Signal } from '@angular/core';
import { ScheduleDetailsVM } from '@libs/schedule';

export const MY_COLLABORATION_SIDEBAR_APPOINTMENT = new InjectionToken<Signal<ScheduleDetailsVM | undefined>>(
  'MY_COLLABORATION_SIDEBAR_APPOINTMENT',
);
